import React from 'react';
import { ExtraStyleType, FieldCustom } from '../FieldCustom/FieldCustom';

export default function SelectFieldCustom({
  disabled,
  extraStyle,
  label,
  name,
  options,
  required,
}: {
  disabled?: boolean;
  extraStyle?: ExtraStyleType;
  label: string;
  name: string;
  options: OptionType[];
  required?: boolean;
}): JSX.Element {
  return (
    <>
      <FieldCustom
        as="select"
        disabled={disabled}
        extraStyle={extraStyle}
        label={label}
        name={name}
        required={required}
        type="select"
      >
        {options?.map(option => {
          const { disabled, label, selected, value } = option;
          return (
            <option
              key={value}
              value={value}
              {...(disabled && { disabled: true })}
              {...(selected && { selected: true })}
            >
              {label}
            </option>
          );
        })}
      </FieldCustom>
    </>
  );
}

type OptionType = {
  disabled?: boolean;
  label: string;
  selected?: boolean;
  value: string;
};
